<script lang="ts" module>
  import type { Snippet } from 'svelte';

  export interface PageCardProps {
    children?: Snippet;
    class?: string;
  }
</script>

<script lang="ts">
  let { ...props }: PageCardProps = $props();
</script>

<div
  class="flex min-h-[528px] w-[540px] flex-col gap-6 rounded-md bg-white px-6 pb-12 pt-6 shadow-card {props?.class}"
>
  {@render props.children?.()}
</div>
